import React from "react";

import { css } from "@emotion/core";
import styled from "@emotion/styled";

import OilFinder from "../../../pages/OilFinder";

const Container = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.left}
        ${theme.paddings.containerOuter.right}

        margin-top: 5em;
        color: ${theme.colors.blue.toString()};
    `}
`;

const OilFinderElement = () => {
    return (
        <Container>
            <OilFinder />
        </Container>
    );
};

export default OilFinderElement;
